import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/amenities")({
  component: Amenities,
});

function Amenities() {
  const { data: user, isLoading } = trpc.user.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
